import React from "react";
import ReactLogo from "../assets/images/logo.svg";

const LogoPortfolio = () => {
  return (
    <a  href="/" className="logo" id="logo"> 
      <img src={ReactLogo} alt="logo" className="logo__img rotate-center" />
      <span>Amit Singh</span>
    </a>
  );
};

export default LogoPortfolio;
